import { IExecutionOptions, IQueryOptions } from '../../models/query';
import { BaseTransform } from './BaseTransform';
import { isArrayLike } from '../../utils/isArrayLike';
import { ConditionalHelper } from '../../helpers/ConditionalHelper';

export class ConditionalTransform extends BaseTransform {
	execute(queryResponse: any[], queryOptions: IQueryOptions, executionOptions: IExecutionOptions) {
		const { conditional } = this.options;
		const conditionalHelper = new ConditionalHelper(conditional, this.translationHelper);
		return conditionalHelper.matchesWithOptions({
			executionOptions,
			instance: queryResponse,
		});
	}
}